module.exports = __webpack_public_path__ + "img/2.328f14cb.jpg";